<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Device')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">

            <FloatingLabel v-model="details.uuid" label="Device Uuid" size="sm" />
            <FloatingLabel v-model="details.name" label="Name" size="sm" :readonly="true"/>
            <FloatingLabel v-model="details.type" label="Type" size="sm" :readonly="true"/>

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.tenant_id">{{$t('Tenant')}}</div>
              <multiselect
                v-model="details.tenant_id"
                :options="tenantsList"
                placeholder="Select tenant (optional)"
                :multiple="false"
                track-by="brand_name"
                label="brand_name"
                :translate="false"
                :disabled="true"
              ></multiselect>
            </div>

            <div class="mb-2 position-relative">
              <div class="multiselect-lbl text-muted">{{$t('Shop')}}</div>
              <multiselect
                v-model="details.shop_id"
                :options="shopsList"
                placeholder="Select shop (mandatory)"
                :multiple="false"
                track-by="eid"
                label="name"
                :translate="false"
                :disabled="true"
              ></multiselect>
            </div>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import LimitsListEditor from "@/components/LimitsListEditor";
import ListEditor from "@/components/ListEditor";
import { evbus, EVENTS } from "@/shared/evbus";

export default {
  name: "device",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel,
    LimitsListEditor,
    ListEditor,
  },

  data: function() {
    return {
      eid: "",
      details: {
        uuid: "",
        name: "",
        type: "",
        shop_id: null,
        tenant_id: null,
      },

      newId: false,
      temp: {}
    };
  },

  computed: {
    tenantsList() {
      return this.$store.getters["cache/tenants"];
    },
    allShopsList() {
      return this.$store.getters["cache/shops"];
    },
    shopsList(){
      if (!this.details.tenant_id || !this.details.tenant_id.eid) { return this.allShopsList }
      const tmp = [];
      this.allShopsList.forEach(shop => {
        if (shop && shop.etenant_id && shop.etenant_id == this.details.tenant_id.eid) { tmp.push(shop) }
      });
      return tmp;
    }
  },

  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "shops").catch(e => e),
      this.$store.dispatch("cache/fetch", "tenants").catch(e => e)
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },

  methods: {

    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
        this.$store.dispatch("cache/fetch", "tenants").catch(e => e)
      ])
        .catch(err => {})
        .finally(() => {
          this.$store
            .dispatch("device/read", this.eid)
            .then(resp => {
              this.temp = resp.data;
              this.populateData(resp.data);
            })
            .catch(err => {
              this.showErrorNotification(err);
            })
            .finally(() => {
              loader.close();
            });
        });

    },

    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "device/update";
      if (this.newId) {
        apiAction = "device/create";
      } else {
        detailsData.eid = this.eid;
      }

      if (detailsData.tenant_id) {
        detailsData.etenant_id = detailsData.tenant_id.eid;
        delete detailsData.tenant_id;
      }

      if (detailsData.shop_id) {
        detailsData.eshop_id = detailsData.shop_id.eid;
        delete detailsData.shop_id;
      } else {
        detailsData.eshop_id = "";
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Device updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            this.eid = resp.data.id;
            this.loadData();
            msg = "Device created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },

    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.uuid = r.uuid;
      this.details.name = r.name;
      this.details.type = r.type;
      this.details.shop_id = r.eshop_id;
      this.details.tenant_id = r.etenant_id;

      if (this.details.tenant_id) {
        this.tenantsList.forEach(element => {
          if (element.eid == this.details.tenant_id) {
            this.details.tenant_id = element;
            return;
          }
        });
      }

      if (this.details.shop_id) {
        this.allShopsList.forEach(element => {
          if (element.eid == this.details.shop_id) {
            this.details.shop_id = element;
            return;
          }
        });
      }

    },

    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Device", params: { id: id } });
    },

    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },

    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },

  }
};
</script>

<style lang="scss" scoped>
</style>
